import { Button, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { orange } from 'bold-ui/lib/styles/colors'
import { Box } from 'components/Box'
import { HLabel } from 'components/HLabel'
import theme from 'config/theme'
import { css } from 'emotion'
import { Cbo, Equipe, Profissional, UnidadeSaude } from 'graphql/types.generated'
import { formatNomeProfissional } from 'view/profissional/utils/utils-profissional'

import { formatEquipeLotacaoResponsavel, formatUnidadeSaudeLotacaoResponsavel } from './utils/utils-lotacaoResponsavel'

type ProfissionalResponsavelCardModel = Pick<Profissional, 'id' | 'nome' | 'nomeSocial'>

type CboResponsavelCardModel = Pick<Cbo, 'id' | 'nome'>

type UnidadeSaudeResponsavelCardModel = Pick<UnidadeSaude, 'id' | 'nome'> & { cnes?: string }

type EquipeResponsavelCardModel = Pick<Equipe, 'id' | 'nome'> & { ine?: string }

export interface LotacaoResponsavelCardModel {
  profissional?: ProfissionalResponsavelCardModel | null
  cbo?: CboResponsavelCardModel | null
  unidadeSaude?: UnidadeSaudeResponsavelCardModel | null
  equipe?: EquipeResponsavelCardModel | null
}

interface LotacaoResponsavelCardProps {
  responsavel: LotacaoResponsavelCardModel
  isLotacaoActive?: boolean
  onAlterarResponsavel?: () => void
  hideProfissional?: boolean
  hideCbo?: boolean
  equipeLabel?: string
  equipeFallbackLabel?: string
  alterarResponsavelLabel?: string
}

export function LotacaoResponsavelCard(props: LotacaoResponsavelCardProps) {
  const {
    responsavel,
    isLotacaoActive,
    onAlterarResponsavel,
    hideProfissional = false,
    hideCbo = false,
    equipeLabel = 'Equipe',
    equipeFallbackLabel = 'Sem equipe',
    alterarResponsavelLabel = 'Alterar responsável',
  } = props
  const { profissional, cbo, unidadeSaude, equipe } = responsavel

  return (
    <Box style={styles.box}>
      <HFlow alignItems='center' justifyContent='space-between'>
        <VFlow vSpacing={0}>
          {!hideProfissional && (
            <Text fontWeight='bold'>
              {profissional != null ? formatNomeProfissional(profissional) : 'Sem responsável definido'}
            </Text>
          )}
          {!hideCbo && (
            <HFlow
              alignItems='center'
              style={css`
                grid-gap: 0.25rem;
              `}
            >
              <HLabel title='CBO'>{profissional != null ? cbo?.nome?.capitalize() ?? 'Não informado' : null}</HLabel>
              {isLotacaoActive === false && <Icon icon='exclamationTriangleFilled' size={1} color={orange.c40} />}
            </HFlow>
          )}
          <HLabel title={equipeLabel}>{formatEquipeLotacaoResponsavel(equipe, equipeFallbackLabel)}</HLabel>
          <HLabel title='Unidade de saúde'>{formatUnidadeSaudeLotacaoResponsavel(unidadeSaude)}</HLabel>
        </VFlow>

        {onAlterarResponsavel && (
          <Button onClick={onAlterarResponsavel} size='small'>
            <HFlow hSpacing={0.5}>
              <Icon icon='exchange' />
              {alterarResponsavelLabel}
            </HFlow>
          </Button>
        )}
      </HFlow>
    </Box>
  )
}

const styles = {
  box: css`
    border: 1px solid ${theme.pallete.gray.c60};
  `,
}
